<template>
  <div class="subscribers">
    <md-table v-if="$store.state.pageLoaded" class="subscribers-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" v-on:click="$store.state.dialogs.add = true; $store.state.dialogs.edit = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptySubscriber))" v-if="$store.state.schema.subscriber.create" title="Dodaj pretplatnika">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Pretplatnici</h1>
          <md-button class="md-accent md-dense md-raised download-subscribers" @click="$store.dispatch('getExport', 'subscribers')">
            Preuzmi
          </md-button>
          <md-field>
            <label>Pretplata</label>
            <md-select v-model="subsciptionID">
              <md-option v-for="subscription in $store.state.receivedData.subscriptionBundle.list" :value="subscription.id">
                {{ subscription.title }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <md-field md-clearable class="md-toolbar-section-end search-field">
          <md-icon>search</md-icon>
          <md-input placeholder="Pretraži..." v-model="searchKey"/>
        </md-field>
      </md-table-toolbar>

      <md-table-empty-state
        md-label="Nije pronađen niti jedan pretplatnik"
        :md-description="`Nema rezultata za '${searchKey}'. Pokušajte ponovno...`">
      </md-table-empty-state>

      <md-table-row v-if="$store.state.receivedData.subscribers.list.length > 0">
        <md-table-head>ID</md-table-head>
        <md-table-head>Ime</md-table-head>
        <md-table-head>Email</md-table-head>
        <md-table-head>Telefon</md-table-head>
        <md-table-head>Pretplate</md-table-head>
        <md-table-head>Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.subscribers.list" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))" v-if="$store.state.receivedData.subscribers.list.length > 0">
        <md-table-cell md-numeric>{{ item.id }}</md-table-cell>
        <md-table-cell>{{ item.first_name }} {{ item.last_name }}</md-table-cell>
        <md-table-cell>{{ item.email }}</md-table-cell>
        <md-table-cell>{{ item.mobile_phone }}</md-table-cell>
        <md-table-cell>
          <span class="subscriber-transaction" v-for="subscription in item.subscriptions" v-on:click="$store.dispatch('setActiveTab', 'transactionDetails'); $store.dispatch('getTransactions', subscription.transaction)">
            {{ subscription.subscription }} {{ subscription.subscription_number }} <span v-if="subscription.holder">- Nositelj</span><br>
          </span>
        </md-table-cell>
        <md-table-cell>
          <md-button class="md-icon-button md-accent" v-on:click="$store.state.dialogs.delete = true" v-if="$store.state.schema.subscriber.delete" title="Obriši">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="$store.state.dialogs.edit = true; $store.state.dialogs.add = false" title="Uredi" v-if="$store.state.schema.subscriber.update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
		<SubscribersDialog/>

    <div class="export" ref="export">
      <div v-for="i in Array.from({length: numberOfPages}, (x,i) => i)" class="single-page" v-if="$store.state.receivedData.subscribers.list.length > 0">
        <div v-for="j in Array.from({length: personPerPage}, (x,j) => j)" class="single-export">
          <div v-if="$store.state.receivedData.subscribers.list[j+i*personPerPage] !== undefined" class="single-export-inner">
            <p>{{ $store.state.receivedData.subscribers.list[j+i*personPerPage].first_name }} {{ $store.state.receivedData.subscribers.list[j+i*personPerPage].last_name }}</p>
            <p>{{ $store.state.receivedData.subscribers.list[j+i*personPerPage].address }}</p>
            <p>{{ $store.state.receivedData.subscribers.list[j+i*personPerPage].postal_code }},&nbsp;{{ $store.state.receivedData.subscribers.list[j+i*personPerPage].city }}</p>
          </div>
        </div>
      </div>
    </div>

    <md-button class="md-primary md-dense md-raised print-btn fixed-print-btn" v-on:click="showStickers()" v-if="$store.state.receivedData.subscribers.list.length > 0">
      Ispiši naljepnice
    </md-button>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Printd from 'printd'

export default {
  name: 'Subscribers',
  data(){
    return {
      rows: 6,
      columns: 3,
      searchKey: '',
      subsciptionID: '',
      searchedProperties: ['full_name', 'mobile_phone', 'email'],
      emptySubscriber: {
        email: '',
        last_name: '',
        first_name: '',
        mobile_phone: '',
      }
    }
  },

  computed: {
    ...mapGetters([
      'isPageLoaded',
    ]),

    numberOfPages(){
      return Math.ceil(this.$store.state.receivedData.subscribers.list.length/this.personPerPage)
    },

    personPerPage(){
      return this.rows*this.columns;
    }
  },

  methods: {
    onSubscriberSelect(item){
			this.$store.state.selectedObject = JSON.parse(JSON.stringify(item));
    },

    async showStickers(){
      this.$store.state.loading = true;
      this.print(this.$refs.export);
      this.$store.state.loading = false;
    },

    print(component){
      let p = new Printd();
      let css = [`
      .single-page{
        page-break-after: always;
        display: flex;
        flex-wrap: wrap;
        min-height: 100%;
      }

      .single-page:not(:first-of-type){
        margin-top: 10px;
      }

      .export{
        min-height: 100%;
        width: 100%;
        font-size: 0;
      }

      .export .single-export-inner{
        position: absolute;
        top: 20px;
        left: 15px;
        bottom: 20px;
      }

      .export .single-export{
        position: relative;
        min-width: 33.3333%;
        max-width: 33.3333%;
        min-height: 42.0mm;
        max-height: 42.0mm;
        overflow:hidden;
      }

      .export p{
        font-family: 'Arial';
        margin: 0;
        line-height: 1.5;
        font-size: 14px;
      }

      .export p + p{
        margin-top: 5px;
      }`]
      p.print(component, css)
    },
  },

  watch:{
    async subsciptionID(){
      this.$store.state.loading = true;
      await this.$store.dispatch('getSubscribers', {name: this.searchKey, subscription: this.subsciptionID})
      this.$store.state.loading = false;
    },

    async searchKey(value){
      clearTimeout(this.timeout);
      if(value.length > 1) this.$store.state.loading = true;
      else this.$store.state.receivedData.subscribers.list = [];
      this.timeout = setTimeout(async () => {
        if(value != '' && value.length > 1) await this.$store.dispatch('getSubscribers', {name: this.searchKey, subscription: this.subsciptionID})
        this.$store.state.loading = false;
      }, 1000);
    },
  }
}
</script>

<style lang="scss">
.subscribers-table{
  table-layout: fixed;
  .md-table-head, .md-table-cell{
    vertical-align: top;
    &:last-of-type{
      text-align: center;
    }
  }
}

.md-toolbar-section-start{
  .md-field{
    max-width: 300px;
    margin-right: 30px;
  }
}

.subscribers{
  margin: 0 0 50px;
}

.subscriber-transaction{
  font-weight: bold;
  &:hover{
    text-decoration: underline;
  }
}

.export{
  display: none;
}

.download-subscribers{
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Subscriptions/Subscribers.vue